import { Box, Button, Checkbox, Field, Flex, Grid, GridItem, Heading, HStack, Icon, IconButton, Image, Input, Link, Span, Stack, Text, Textarea, VStack } from '@chakra-ui/react'
import React, { useEffect, useState, useRef } from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { LuAtSign,  LuLocate,  LuPhone } from 'react-icons/lu'
import { FaFacebook, FaLinkedin, FaTiktok, FaWhatsappSquare } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { getCalApi } from "@calcom/embed-react";
import emailjs from '@emailjs/browser';

const OurLocation = () => {

  // Définir les informations de l'e-mail
  const destinataire = "hello@escrutin.net";


  const [mailBody, setMailBody] = useState("Madame, Monsieur,\nJe me permets de vous contacter au nom de [le nom de votre entreprise] car nous avons suivi avec intérêt vos récentes réalisations dans le domaine de l'innovation technologique.\nDans le cadre de notre croissance, nous souhaitons vous contactez afin de [motif]")
  const [senderMail, setSenderMail] = useState('')
  const [userName, setUserName] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [choose, setChoose] = useState([])
  const [isValid, setIsValid] = useState(false)


  const handleMailSend =async()=>{
    setIsLoading(true)
    let temp = ''
    for(let element of choose){
      temp = temp + ' - ' + element.toString()
    }
    // Ouvrir l'application de messagerie par défaut
    setMailBody(`${mailBody + ' \n Cordialement. \n Notre besoin : ' + temp }`)

    await emailjs.send(
      'service_9ld6ize', 
      'template_ze4v5pn', 
      {
        user_name: userName,
        user_email: senderMail,
      }, 
      'Mx6mCqsifOUa3t7oE'
    )
      .then((result) => {
          setIsLoading(false)
          console.log('Success:', result.text);
          setSenderMail('')
          setMailBody('')
          setUserName('')
          alert("Message envoyé avec succès ! \n Veuillez verifiez votre messagerie pour continuer");

      }, (error) => {
          setIsLoading(false)
          console.log('Failed:', error.text);
          alert("Une erreur s'est produite, veuillez réessayer.");
      });
   
  }

  const handleSelectOption =(value)=>{
    if(choose.includes(value)){
      setChoose(choose.filter(elt=> elt !== value ))
    }else{
      setChoose(prev => [...prev, value])
    }
  }

  //Prendre un rendez vous
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({"namespace":"30min"});
      cal("ui", {"hideEventTypeDetails":false,"layout":"month_view"});
    })();
  }, [])

  // recevoir. un mail
  useEffect(() => {
    setMailBody(
      ` Madame, Monsieur,\nJe me permets de vous contacter au nom de ${userName.toUpperCase()} car nous avons suivi avec intérêt vos récentes réalisations dans le domaine de l'innovation technologique.\nDans le cadre de notre croissance, nous souhaitons vous contactez afin de [motif]`
    )
  }, [userName])
  
  useEffect(() => {
     if(mailBody !== '' && userName !== '' && choose.length !== 0){
      setIsValid(true)
     }else{
      setIsValid(false)
     }
  }, [mailBody, userName, choose])
  


  
  const cardColor = useColorModeValue('white', 'gray.900')
  const textGhost = useColorModeValue('gray.800', 'gray.500')
  let isIOSDevice = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent); // fails on iPad iOS 13
  const {t} = useTranslation()
  const css = `
    .mapouter {
    position:relative;
    text-align:right;
    } 
    .gmap_canvas{
    overflow:hidden;
    background:none;
    } 
    .gmap_canvas iframe{
    width:100%;
    height:100%;
    } 
    .mapouter a{
    display:block;
    font-size:0.85em;
    text-align:center
    ;padding:5px 0;
    color:#6c757d;
    text-decoration:none
    } 
    .gme-generated-link{
    display:none;
    }
`

  return (
    <Flex
      px={{md: '10%', '2xl': "19%", base: 4}}
      py={{'2xl' :20, base: 10}}
      overflow={'hidden'}
      position={'relative'}
      id='our-location'
    >
      <Box w={'full'}>
        <Box w={'full'}>
          <Heading 
          fontFamily={'Outfit'} 
          textTransform={'uppercase'}
          fontSize={{ '2xl': 'xl', md: 'xl', base: 'md' }}
          >
          {t('locationSubtitle')}
          </Heading>

          <Heading lineHeight={1.1} maxW={{ '2xl': '690px', md: '500px', base: 'full'}} mt={{'2xl': 10, base: 0}} fontWeight={600} letterSpacing={-1.8} fontFamily={'Poppins'} fontSize={{'2xl': '7xl', md: '3xl', base: '2xl'}}>
           {t('locationTitle')} 
           <Span
            bgGradient={'to-r'} 
            gradientFrom={ 'blue.500'}  
            gradientTo={'purple.600'}
            bgClip={'text'}
            >
              {t('locationTitleHighlight')}
            </Span>
          </Heading>
        </Box>

        <Grid gridTemplateColumns={{'2xl': '3fr 2fr', md: '3fr 2fr', base: '1fr'}} w={'full'} gap={10}>
          <GridItem w={'full'}>
            <Flex position={'relative'} mt={14} minH={'60vh'} flexDir={{'2xl': 'row', md: 'row', base: 'column'}} w={'full'} p={{'2xl' : 8, base: 2}} py={10} boxShadow={'md'} gap={10} bgColor={cardColor} rounded={28}>
              <Box px={{'2xl': 'inherit', base: '4'}}>
                <HStack align={'start'} mt={2} py={3}>
                  <Icon boxSize={6}>
                    <LuAtSign/>
                  </Icon>
                  <Box>
                    <Text fontWeight={500}>{t('locationAddress1Title')}</Text>
                    <Text fontSize={'sm'} color={textGhost}>
                      {t('locationAddress1Description')}
                    </Text>
                    {/* prendre rendez vous */}
                    <Link data-cal-namespace="30min"
                    data-cal-link="support-escrutin/30min"
                    data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true"}'
                    fontSize={'sm'} mt={1} color='blue.500'>
                    {t('locationLink1')}
                    </Link>
                  </Box>
                </HStack>

                <HStack align={'start'} py={3}>
                  <Icon boxSize={6}>
                    <LuLocate/>
                  </Icon>
                  <Box>
                    <Text fontWeight={500}>{t('locationAddress2Title')}</Text>
                    <Text fontSize={'sm'} color={textGhost}>
                      {t('locationAddress2Description')}
                    </Text>
                    <Link fontSize={'sm'} mt={1} color='blue.500'>{t('locationLink2')}</Link>
                  </Box>
                </HStack>

                <HStack align={'start'} py={3}>
                  <Icon boxSize={6}>
                    <LuPhone/>
                  </Icon>
                  <Box>
                    <Text fontWeight={500}>{t('locationAddress3Title')}</Text>
                    <Text fontSize={'sm'} color={textGhost}>
                      {t('locationAddress3Description')}
                    </Text>
                    <Text fontFamily={'Onest'} fontSize={'sm'} mt={1} color='blue.500'>+237 6 97 00 82 83</Text>
                  </Box>
                </HStack>
              </Box>


              {/* NETWORK  */}

              <HStack gap={4} position={'absolute'} justify={{'2xl': 'inherit', md: 'inherit', base: 'center'}} w={{'2xl': 'inherit', base: 'full'}} bottom={{'2xl' :10, md: 10, base: 12}} left={{'2xl' :10, md: 4, base: 0}}>
                <IconButton variant={'ghost'} size={'lg'} rounded={'full'}>
                  <FaFacebook/>
                </IconButton>
                <IconButton variant={'ghost'} size={'lg'} rounded={'full'}>
                  <FaWhatsappSquare/>
                </IconButton>
                <IconButton variant={'ghost'} size={'lg'} rounded={'full'}>
                  <FaLinkedin/>
                </IconButton>
                <IconButton variant={'ghost'} size={'lg'} rounded={'full'}>
                  <FaTiktok/>
                </IconButton>
              </HStack>

              <Box 
              rounded={28} 
              w={'full'}
              bgGradient={'to-bl'} 
              gradientFrom={useColorModeValue('blue.50', 'blue.800')}  
              gradientTo={useColorModeValue('purple.50', 'purple.800')}
              p={{'2xl' :8, base: 6}}
              py={{'2xl' :8, base: 8}}
              >
                <Heading fontFamily={'Poppins'} maxW={{ '2xl' :'400px', base: 'full'}} letterSpacing={-1.2} lineHeight={1.3} fontSize={{'2xl': '2xl', base: 'xl'}}>
                  {t('locationFormTitle')}
                </Heading>

                <Text mt={{'2xl' :8, base: 2}} fontSize={{'2xl': 'lg', base: 'md'}}>
                  {t('locationFormDescription')}
                </Text>


                <Box mt={10}>
                  <Field.Root required>

                    <Input borderTop={'none'} borderLeft={'none'} borderRight={'none'} rounded={'none'} placeholder={t('placeholder1')} 
                      value={userName}
                      onChange={e=> setUserName(e.target.value)}
                      _focusVisible={{
                        outline: 'none',
                        borderLeft: 'none',
                        borderRight:'none'
                      }}
                    />
                  </Field.Root>

                  <Field.Root mt={8} required>
                    <Input borderTop={'none'} borderLeft={'none'} borderRight={'none'} rounded={'none'} placeholder={t('placeholder2')} 
                      onChange={e=>setSenderMail(e.target.value) }
                      value={senderMail}
                      _focusVisible={{
                        outline: 'none',
                        borderLeft: 'none',
                        borderRight:'none'
                      }}
                    />
                  </Field.Root>

                  <Field.Root mt={8} required>
                    <Textarea borderTop={'none'} borderLeft={'none'} borderRight={'none'} rounded={'none'} placeholder={t('placeholder3')} 
                      onChange={e=> setMailBody(e.target.value)}
                      value={mailBody}
                      _focusVisible={{
                        outline: 'none',
                        borderLeft: 'none',
                        borderRight:'none'
                      }}
                    />
                  </Field.Root>
                </Box>

                <Text mt={20} fontWeight={500}>{t('checkboxTitle')}</Text>
                <Stack mt={8} align="flex-start">
                  
                  <Checkbox.Root onCheckedChange={()=> handleSelectOption(t('checkboxOption1'))}>
                    <Checkbox.HiddenInput />
                    <Checkbox.Control />
                    <Checkbox.Label>{t('checkboxOption1')}</Checkbox.Label>
                  </Checkbox.Root>
                  
                  <Checkbox.Root onCheckedChange={()=> handleSelectOption(t('checkboxOption2'))}>
                    <Checkbox.HiddenInput />
                    <Checkbox.Control />
                    <Checkbox.Label>{t('checkboxOption2')}</Checkbox.Label>
                  </Checkbox.Root>
                
                  <Checkbox.Root onCheckedChange={()=> handleSelectOption(t('checkboxOption3'))}>
                    <Checkbox.HiddenInput />
                    <Checkbox.Control />
                    <Checkbox.Label>{t('checkboxOption3')}</Checkbox.Label>
                  </Checkbox.Root>
                  
                  <Checkbox.Root onCheckedChange={()=> handleSelectOption(t('checkboxOption4'))}>
                    <Checkbox.HiddenInput />
                    <Checkbox.Control />
                    <Checkbox.Label>{t('checkboxOption4')}</Checkbox.Label>
                  </Checkbox.Root>
                
                </Stack>


                <Button disabled={!isValid} loading={isLoading} onClick={handleMailSend} mt={10} mb={{'2xl': 'inherit', base: 7}} w={'full'} size={{'2xl': 'xl', base: 'md' }} fontFamily={'Momo Trust Display'} fontWeight={ isIOSDevice ? 'medium' : 'normal'}>
                  {t('submitButton')}
                </Button>

              </Box>



            </Flex>

          </GridItem>

          <GridItem w={'full'}>
            <Box w={'full'} mt={10}>
              <VStack align={'end'} w={'full'} gap={8}>
                <Flex 
                px={3} 
                rounded={'full'} 
                bgGradient={'to-r'} 
                gradientFrom={useColorModeValue('blue.100', 'blue.800')}  
                gradientTo={useColorModeValue('purple.200', 'purple.700')} 
                >
                  <Heading fontFamily={'Poppins'} fontSize={{'2xl': 'xl', base: 'md'}} letterSpacing={-1.2}>
                    {t('MapSubtitle')}
                  </Heading>
                </Flex>

                <Box textAlign={'right'} maxW={'400px'}>
                  <Text fontSize={'md'}>                
                    {t('MapDescription')}
                  </Text>
                </Box>
              </VStack>

              <Flex gap={4} h={'full'} justify={'center'} mt={{'2xl': 'inherit', base: 4}} flexGrow={1} w={'full'}>
                <Flex boxShadow={'md'} justify={'center'} align={'center'} rounded={20} bgColor={cardColor} p={{'2xl' :2, base: 2}}>
                  <Box
                  bgImage={`url(${require('../../../assets/team/1.jpeg')})`}
                  bgSize={'cover'}
                  bgRepeat={'no-repeat'}
                  boxSize={{'2xl' :'120px', base: '90px'}}
                  rounded={20}
                  />
                </Flex>
                <Flex  bgColor={useColorModeValue('purple.100', 'purple.400')} boxShadow={'md'} justify={'center'} align={'center'} rounded={'full'} p={{'2xl' :2, base: 2}}>
                  <Box
                  bgImage={`url(${require('../../../assets/team/3.jpeg')})`}
                  bgSize={'cover'}
                  bgRepeat={'no-repeat'}
                  boxSize={{'2xl' :'120px', base: '90px'}}
                  rounded={'full'}
                  />
                </Flex>
                <Flex boxShadow={'md'} justify={'center'} align={'center'} rounded={20} bgColor={cardColor} p={{'2xl' :2, base: 2}}>
                  <Box
                  bgImage={`url(${require('../../../assets/team/2.jpeg')})`}
                  bgSize={'cover'}
                  bgRepeat={'no-repeat'}
                  boxSize={{'2xl' :'120px', base: '90px'}}
                  rounded={20}
                  />
                </Flex>
              </Flex>

              <Box boxShadow={'md'} mt={10} rounded={24} bgColor={cardColor} p={4}>
                <Heading px={2} fontFamily={'Poppins'} fontSize={{'2xl' :'lg', base: 'md'}} letterSpacing={-1.2} >CCA Bank. &nbsp; petit-marche fourgreol</Heading>

                <Box mt={3}>
                  <div className="mapouter" style={{position:'relative', textAlign: 'right', width: '100%', minHeight:'450px'}}>
                    <div className="gmap_canvas" 
                      style={{
                        overflow: 'hidden', background:'none', width: '100%', minHeight:'450px'}}>
                      <iframe title='llocation' style={{ border: 0, borderRadius: '20px', width: '100%', minHeight:'450px'}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" src="https://www.google.com/maps/embed/v1/place?q=escrutin&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe>
                    </div>
                    <style>
                      {css}
                    </style>
                  </div>
                </Box>

              </Box>



            </Box>
          </GridItem>
        </Grid>
      </Box>
        
    </Flex>
  )
}

export default OurLocation